export const normalizePipeline = value => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

const isPipelineA = pipelineValue => {
  const normalizedValue = normalizePipeline(pipelineValue).toLowerCase();
  return normalizedValue === 'pipeline a' || normalizedValue === 'a';
};

const isPipelineB = pipelineValue => {
  const normalizedValue = normalizePipeline(pipelineValue).toLowerCase();
  return normalizedValue === 'pipeline b' || normalizedValue === 'b';
};

export const filterProjectsInPreparationByHeader = (projects, selectedPreparationYear = 0, selectedPipelineLabel = '') =>
  projects.filter(project => {
    const matchesYear =
      selectedPreparationYear === 0 ||
      Number(project.field7) === selectedPreparationYear;
    const matchesPipeline =
      selectedPipelineLabel === '' || normalizePipeline(project.field6).toLowerCase() === selectedPipelineLabel.toLowerCase();

    return matchesYear && matchesPipeline;
  });

export const getProjectsInPreparationPipelineCounts = projects => {
  return projects.reduce(
    (accumulator, project) => {
      if (isPipelineA(project.field6)) {
        accumulator.pipelineACount += 1;
      }

      if (isPipelineB(project.field6)) {
        accumulator.pipelineBCount += 1;
      }

      return accumulator;
    },
    { pipelineACount: 0, pipelineBCount: 0 },
  );
};
